// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';
import './CategorySelector.css';

export default function CategorySelector({ categories, onSelect }) {
  // Use tenant-configured categories if available, fall back to defaults
  const items = categories && categories.length > 0 ? categories : DEFAULT_CATEGORIES;

  return (
    <div className="category-selector">
      <div className="category-selector__intro">
        <h2 className="category-selector__heading">What area would you like to share feedback on?</h2>
        <p className="category-selector__subtext">
          Select the category that best matches your feedback. You can always provide additional context in your recording.
        </p>
      </div>
      <div className="category-selector__grid" role="list">
        {items.map((cat) => (
          <button
            key={cat.id}
            className="category-card"
            onClick={() => onSelect(cat)}
            role="listitem"
            aria-label={`Select ${cat.label} feedback category`}
          >
            <span className="category-card__icon" aria-hidden="true">{cat.icon || '📋'}</span>
            <span className="category-card__label">{cat.label}</span>
            {cat.description && (
              <span className="category-card__desc">{cat.description}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

const DEFAULT_CATEGORIES = [
  { id: 'general', label: 'General', description: 'Overall experience and operations', icon: '🏛️' },
  { id: 'feedback', label: 'Feedback', description: 'General feedback and suggestions', icon: '💬' },
];
